import { ToothStatus } from '@/shared/config';

import { isThirdMolarTooth } from './isThirdMolarTooth';

export const isMissingThirdMolarTooth = (
  toothStatus: ToothStatus,
  ISONumber: number,
) => toothStatus === ToothStatus.missing && isThirdMolarTooth(ISONumber);
